<template>
    <div class="m-corp">
        <h5 class="title"></h5>

        <div class="view">
            <div class="corp-list" v-if="ready">
                <div class="corp-item" v-for="(item,index) in list" :key="index">
                    <div class="corp-img">
                        <a :href="item.url" :title="item.title" target="_blank" rel="noopener noreferrer">
                            <img :src="item.logo" :alt="item.title">
                        </a>                       
                    </div>                    
                </div>
            </div>
            <loading v-else/>
        </div>
    </div>
</template>

<script>
export default {
    data (){
        return {
            list : [],
            ready : false,
        }
    },
    props :{
        'active' : {
            default : false,
        }
    },
    inject : ['reload'],
    created (){
        // this.render_live();
        // this.render_news();
    },
    watch : {
        active (val){
            if(val && !this.ready){
                this.render();             
            }
        },
    },
    methods : {
        render(){
            let vm = this;
            this.$axios.get(this.$ajax_url_map.corp)
            .then(
                res => {
                    this.list = res
                    this.ready = true
                    
                    setTimeout( ()=> {
                        vm.reload()
                    },1000)
                },
                rej => {}
            )            
        },
    },  
}
</script>

<style scoped>
    .m-corp{
        margin-top: 115px;
    }

    .view{
        position: relative;
        min-height: 306px;
    }

    .title{
        width: 238px;
        height: 57px;
        margin-bottom: 40px;
        background-image: url(~@/assets/images/corp/title.png);        
    }

    .corp-list{
        display: flex;
        flex-wrap: wrap;
    }

    .corp-item{
        width: 266px;
        height: 127px;
        margin: 0 20px 26px;
        background-image: url(~@/assets/images/corp/bg-item.png);  
    }

    .corp-img{
        position: relative;
        width: 100%;
        height: 100%;
    }

     .corp-img a{
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);          
     }

    .corp-img img{
        max-height: 127px;     
    }
</style>


// WEBPACK FOOTER //
// src/components/page/corp.vue